import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthQuery, AuthContext } from './hooks/useAuth'
import { Layout } from './components/Layout'
import { Dashboard } from './pages/Dashboard'
import { Content } from './pages/Content'
import { AIContent } from './pages/AIContent'
import { Platforms } from './pages/Platforms'
import { Analytics } from './pages/Analytics'
import { SEO } from './pages/SEO'
import { Settings } from './pages/Settings'

function App() {
  const { data, isLoading, error } = useAuthQuery()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-primary-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-slate-600">Loading Resonance...</p>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="card max-w-md text-center">
          <h1 className="text-2xl font-bold text-slate-900 mb-2">Authentication Required</h1>
          <p className="text-slate-600 mb-4">
            Please sign in through Cloudflare Access to continue.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="btn-primary"
          >
            Try Again
          </button>
        </div>
      </div>
    )
  }

  const authValue = {
    user: data ? { id: data.id, email: data.email, name: data.name, role: data.role } : null,
    isLoading: false,
    isAuthenticated: !!data,
    error: null,
  }

  return (
    <AuthContext.Provider value={authValue}>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="content" element={<Content />} />
          <Route path="ai-content" element={<AIContent />} />
          <Route path="platforms" element={<Platforms />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="seo" element={<SEO />} />
          <Route path="settings" element={<Settings />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthContext.Provider>
  )
}

export default App
